<template>
  <q-dialog
    v-if="dialogOpen"
    v-model="dialogOpen"
    persistent
  >
    <q-card
      class="full-width"
    >
      <q-card-section class="q-dialog__heading">
        <div class="text-h5 text-primary">
          {{ $t(`types.${type.category}.name`, {price: formatPriceISK(type.price.amount)} ) }}
        </div>
      </q-card-section>

      <q-card-section class="column">
        <q-input
          v-model="licencePlate"
          class="col-12 q-mb-sm"
          outlined
          square
          hide-bottom-space
          autofocus
          no-error-icon
          :label="$t('dialogs.plate.licencePlate')"
          :rules="[
            v => (v.length > 1 || v.length === 0) || $t('errors.licencePlate.noInput')
          ]"
        />
        <q-input
          v-model="email"
          class="col-12"
          outlined
          type="email"
          square
          hide-bottom-space
          no-error-icon
          :label="$t('dialogs.plate.email')"
          :rules="[
            v => ((v.length > 0 && validateEmail(v)) || v.length === 0)
              || $t('errors.licencePlate.invalidEmail')
          ]"
          @keyup.enter="submit"
        />
      </q-card-section>

      <q-card-actions
        class="q-dialog__actions"
      >
        <q-btn
          class="q-dialog__actions--btn no-border-radius col-6 bg-accent text-white"
          :label="$t('dialogs.plate.cancel')"
          @click="closeDialog"
        />
        <q-btn
          class="q-dialog__actions--btn no-border-radius col-6 bg-primary text-white"
          :disable="!isValid()"
          :label="$t('dialogs.plate.continue')"
          @click="submit"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import constants from 'src/common/constants';
import PriceFormatter from 'src/mixins/price';

export default {
  name: 'LicencePlate',
  mixins: [PriceFormatter],

  data() {
    return {
      dialogOpen: false,
      licencePlate: '',
      email: '',
    };
  },

  computed: {
    ...mapState('vehicle', ['type']),
    ...mapGetters('product', ['getProductByCategory']),
  },

  watch: {
    type() {
      this.dialogOpen = this.type !== null;
    },
  },

  methods: {
    ...mapMutations('vehicle', ['atSetVehicleType', 'atSetLicencePlateAndEmail']),
    ...mapMutations('application', ['updateStep']),

    validateEmail(value) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value);
    },

    async submit() {
      if (this.isValid()) {
        await this.atSetLicencePlateAndEmail({
          licencePlate: this.licencePlate,
          email: this.email.length ? this.email : null,
        });

        if (process.env.PROVIDER === constants.PAYMENT_PROVIDER_VALITOR) {
          await this.$router.push({ name: 'ValitorPayPayment' });
        }
        else if (process.env.PROVIDER === constants.PAYMENT_PROVIDER_VERIFONE) {
          await this.$router.push({ name: 'VerifonePayment' });
        }

        this.updateStep(2);
      }
    },

    isValid() {
      if (this.licencePlate.length >= constants.PLATE_NUMBER_MINLENGTH) {
        if (!this.email.length) {
          return true;
        }
        return !!(this.email.length && this.email.includes('@') && this.email.includes('.'));
      }
      return false;
    },

    closeDialog() {
      this.atSetVehicleType({ type: null });
      this.clearForm();
    },

    clearForm() {
      this.licencePlate = '';
      this.email = '';
    },
  },
};
</script>
